"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMediaLink = exports.getDateFormat = exports.getFilenameFromUrl = exports.capitalize = exports.checkJson = exports.isJson = exports.isJsonString = exports.isJsonWithAvailableLang = exports.usr = exports.getOrg = exports.getDis = exports.getUser = exports.getCountry = exports.us = void 0;
var lodash_1 = require("lodash");
var config_1 = __importDefault(require("../config/config"));
var localStorage_1 = __importDefault(require("../config/localStorage"));
function getLocalUser() {
    return __awaiter(this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("user")];
                case 1:
                    user = _a.sent();
                    return [2 /*return*/, user];
            }
        });
    });
}
function getLocalDisease() {
    return __awaiter(this, void 0, void 0, function () {
        var disease;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("disease")];
                case 1:
                    disease = _a.sent();
                    return [2 /*return*/, disease];
            }
        });
    });
}
function getLocalOrg() {
    return __awaiter(this, void 0, void 0, function () {
        var organization;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("organization")];
                case 1:
                    organization = _a.sent();
                    return [2 /*return*/, organization];
            }
        });
    });
}
function getLocalCountry() {
    return __awaiter(this, void 0, void 0, function () {
        var country;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("country")];
                case 1:
                    country = _a.sent();
                    return [2 /*return*/, country];
            }
        });
    });
}
function getCountry() {
    var country = getLocalCountry()
        .then(function (response) { return response; })
        .then(function (response) { return response; });
    return country;
}
exports.getCountry = getCountry;
function getUser() {
    var user = getLocalUser()
        .then(function (response) { return response; })
        .then(function (response) { return response; });
    return user;
}
exports.getUser = getUser;
function getDis() {
    var disease = getLocalDisease()
        .then(function (response) { return response; })
        .then(function (response) { return response; });
    return disease;
}
exports.getDis = getDis;
function getOrg() {
    var org = getLocalOrg()
        .then(function (response) { return response; })
        .then(function (response) { return response; });
    return org;
}
exports.getOrg = getOrg;
function usr() {
    return getUser();
}
exports.usr = usr;
function isJsonWithAvailableLang(str, currentLang, t) {
    try {
        var foundlang = JSON.parse(str)[currentLang];
        if (foundlang) {
            return foundlang;
        }
        var fallbackLang = JSON.parse(str).rn;
        if (fallbackLang) {
            return fallbackLang;
        }
        else {
            var fallbackLang_1 = JSON.parse(str).en
                ? JSON.parse(str).en
                : JSON.parse(str).fr;
            return fallbackLang_1;
        }
    }
    catch (e) {
        return t(str);
    }
}
exports.isJsonWithAvailableLang = isJsonWithAvailableLang;
function isJsonString(str, currentLang, t) {
    try {
        var foundlang = JSON.parse(str)[currentLang];
        if (foundlang) {
            return foundlang;
        }
        return "";
    }
    catch (e) {
        return t(str);
    }
}
exports.isJsonString = isJsonString;
function isJson(str, currentLang, t) {
    try {
        var foundlang = JSON.parse(str)[currentLang];
        if (foundlang) {
            return foundlang;
        }
        return JSON.parse(str).en;
    }
    catch (e) {
        return t(str);
    }
}
exports.isJson = isJson;
function checkJson(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.checkJson = checkJson;
function capitalize(str) {
    var replace = str.replace(/\s/g, ""), lower = replace.toLowerCase();
    return "   ".concat(replace.charAt(0).toUpperCase() + lower.slice(1));
}
exports.capitalize = capitalize;
function getFilenameFromUrl(url /* currentLang?: any */) {
    // return  isJsonString()?JSON.parse(url)[currentLang]:'';
    // let parsed = url;
    //
    // if (checkJson(url)) {
    //
    //     parsed = JSON.parse(url)[currentLang];
    //     if (parsed !== null && parsed) {
    //
    //         const {pathname} = new URL(parsed),
    //             index = pathname.lastIndexOf("/");
    //         return index !== -1
    //             ? pathname.substring(index + 1)
    //             : pathname;
    //
    //     }
    //     return null;
    // }
    // if (parsed !== "") {
    var pathname = new URL(url).pathname, index = pathname.lastIndexOf("/");
    return index !== -1 ? pathname.substring(index + 1) : pathname;
    // }
    // return null;
}
exports.getFilenameFromUrl = getFilenameFromUrl;
function getDateFormat(value) {
    var month = ("0" + (value.getMonth() + 1)).slice(-2);
    var date = ("0" + value.getDate()).slice(-2);
    var year = value.getFullYear();
    var shortDate = year + "-" + month + "-" + date;
    return shortDate;
}
exports.getDateFormat = getDateFormat;
function generateMediaLink(path, organization, country) {
    if (organization && !(0, lodash_1.isEmpty)(country)) {
        var url = "".concat(config_1.default.app_url, "/api/media_link?path=").concat(path, "&organization=").concat(parseInt(organization), "&country=").concat(country === null || country === void 0 ? void 0 : country.toLocaleLowerCase());
        return url;
    }
    else {
        return "";
    }
}
exports.generateMediaLink = generateMediaLink;
